var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsOptional } from 'class-validator';
export class CreateUserAuthorityDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "vendor", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "product", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "history", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "accounting", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "maintenance", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "board", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "preallocation", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "d2c", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateUserAuthorityDto.prototype, "analytics", void 0);
